"use client"

import { Col, Row } from "antd"
import TourCard from "../TourCard"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import Carousel from "@/components/common/Carousel"
import { useAppSelector } from "@/lib/redux/hooks"
import { useTranslation } from "react-i18next"

const NearlySeenTours = () => {
  const isDesktop = useIsDesktop()
  const currentlyTours = useAppSelector(state => state.tour.rencentlyChoosenTours)
  const { t } = useTranslation()

  if (!isDesktop || !currentlyTours.length) {
    return <></>
  }

  return (
    <>
      <Row>
        <Title level={3}>
          {t("tour.nearly_seen_tours_title")}
        </Title>
      </Row>
      {isDesktop ? (
        <Row gutter={[10, 10]}>
          {currentlyTours.map((tour) => {
            return (
              <Col span={8}>
                <TourCard tour={tour} size='small' />
              </Col>
            )
          })}
        </Row>
      ) : (
        <Carousel
          className="carousel-main"
          options={{
            pageDots: false,
            cellAlign: "left",
            draggable: true,
            prevNextButtons: false,
            contain: true
          }}
        >
          {currentlyTours.map((tour) => {
            return (
              <div style={{ maxWidth: '80%', paddingRight: '1rem' }}>
                <TourCard tour={tour} size='small' />
              </div>
            )
          })}
        </Carousel>
      )}
    </>
  )
}

export default NearlySeenTours